export default "__VITE_ASSET__B8XVz1DU__"